interface PointerCoordinates {
  x: number;
  y: number;
}

export function normalizeClientCoordinate(
  event: MouseEvent | TouchEvent
): PointerCoordinates {
  let x = -1;
  let y = -1;

  if (event instanceof MouseEvent) {
    x = event.clientX;
    y = event.clientY;
  } else if (event instanceof TouchEvent) {
    x = event.touches[0].clientX;
    y = event.touches[0].clientY;
  }

  return {
    x,
    y,
  };
}

export function relativeCoordinate(
  target: HTMLElement,
  event: MouseEvent | TouchEvent
): PointerCoordinates {
  const coordinates = normalizeClientCoordinate(event);
  const clientRect = target.getBoundingClientRect();

  return {
    x: coordinates.x - clientRect.left,
    y: coordinates.y - clientRect.top,
  };
}
